import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import HomePage from '../pages/HomePage';
import WorkReportPage from '../pages/WorkReportPage';
import InvoicingReportPage from '../pages/InvoicingReportPage';
import RolesPage from '../pages/RolesPage';

import MainLayout from '../components/MainLayout';
import { paths } from '../config/paths';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={paths.home} element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path={paths.reports.workReport} element={<WorkReportPage />} />
          <Route
            path={paths.reports.invoicingReport}
            element={<InvoicingReportPage />}
          />
          <Route path={paths.roles} element={<RolesPage />} />
          <Route path="*" element={<HomePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
